import {
  ALL_DAY_PERIOD,
  DEFAULT_FIRST_END_TIME,
  DEFAULT_FIRST_START_TIME,
  DEFAULT_SECOND_END_TIME,
  DEFAULT_SECOND_START_TIME,
  MINUTES_PER_DAY,
  TIMING_MODES
} from './timingConstants'
import { formatMinutesAsTime, getDayOffset, isZeroPeriod, parsePeriod } from './timingUtils'

const END_OF_DAY_MINUTES = 23 * 60 + 59

const defaultTimingState = () => ({
  mode: TIMING_MODES.ALL_DAY,
  firstStartHour: DEFAULT_FIRST_START_TIME,
  firstEndHour: DEFAULT_FIRST_END_TIME,
  secondStartHour: DEFAULT_SECOND_START_TIME,
  secondEndHour: DEFAULT_SECOND_END_TIME,
  secondOccupationHoursChecked: false
})

const getUtcRange = (period, auxPeriod, offset) => {
  const main = parsePeriod(period)
  const auxiliary = parsePeriod(auxPeriod)
  if (!main) return null

  if (!auxiliary) {
    if (main.start >= main.end) return null
    return { start: main.start, end: main.end }
  }

  if (auxiliary.end === END_OF_DAY_MINUTES && main.start === 0) {
    return {
      start: auxiliary.start - MINUTES_PER_DAY,
      end: main.end
    }
  }

  if (main.end === END_OF_DAY_MINUTES && auxiliary.start === 0) {
    return {
      start: main.start,
      end: auxiliary.end + MINUTES_PER_DAY
    }
  }

  if (main.start === 0 && main.end === 0) {
    const auxDayOffset = offset < 0 ? -1 : offset > 0 ? 1 : 0
    if (!auxDayOffset || auxiliary.start >= auxiliary.end) return null

    return {
      start: auxiliary.start + auxDayOffset * MINUTES_PER_DAY,
      end: auxiliary.end + auxDayOffset * MINUTES_PER_DAY
    }
  }

  return null
}

const convertUtcRangeToLocalTimes = (period, auxPeriod, offset) => {
  const numericOffset = Number(offset)
  if (!Number.isFinite(numericOffset)) return null

  const utcRange = getUtcRange(period, auxPeriod, numericOffset)
  if (!utcRange) return null

  const localStart = utcRange.start - numericOffset
  const localEnd = utcRange.end - numericOffset

  if (getDayOffset(localStart) !== getDayOffset(localEnd) || localStart >= localEnd) {
    return null
  }

  return {
    startHour: formatMinutesAsTime(localStart),
    endHour: formatMinutesAsTime(localEnd)
  }
}

const getTimingStateFromPeriods = ({ period1, period2, auxPeriod, auxPeriod2, offset }) => {
  const defaults = defaultTimingState()

  if (isZeroPeriod(period1) && !parsePeriod(auxPeriod)) return defaults

  const firstSlot = convertUtcRangeToLocalTimes(period1, auxPeriod, offset)
  if (!firstSlot) return defaults

  const secondMainPeriod =
    parsePeriod(period2) || !parsePeriod(auxPeriod2) ? period2 : ALL_DAY_PERIOD
  const secondSlot = convertUtcRangeToLocalTimes(secondMainPeriod, auxPeriod2, offset)

  return {
    ...defaults,
    mode: TIMING_MODES.TIME_SLOT,
    firstStartHour: firstSlot.startHour,
    firstEndHour: firstSlot.endHour,
    ...(secondSlot
      ? {
          secondStartHour: secondSlot.startHour,
          secondEndHour: secondSlot.endHour,
          secondOccupationHoursChecked: true
        }
      : {})
  }
}

export default getTimingStateFromPeriods
